import { AppRouteRecordRaw } from '../types';
import { bmwIndividualPartnerRoutes } from './bmw-individual-partner.routes';

const Body = () => import('@/components/body.vue');
const FleetcorReconliationProcessInfo = () =>
  import('@/pages/individual-partners/fleetcor/FleetcorCsvFormat.vue');
const FleetcorReconciliationDashboard = () =>
  import('@/pages/individual-partners/fleetcor/FleetcorReconciliationDashboard.vue');
const FleetcorJobExecutions = () =>
  import('@/pages/individual-partners/fleetcor/FleetcorJobExecutions.vue');
const FleetcorJobExecutionDetails = () =>
  import('@/pages/individual-partners/fleetcor/FleetcorJobExecutionDetails.vue');
const FleetcorReconciliationFiles = () =>
  import('@/pages/individual-partners/fleetcor/FleetcorReconciliationFiles.vue');
const AccountSettingsIndividualPartner = () =>
  import('@/pages/accountsettings/AccountSettingsIndividualPartner.vue');
const AccountSettingsPolandInvoice = () =>
  import('@/pages/accountsettings/AccountSettingsPolandInvoice.vue');
const RydCallBackApisGeneralInfo = () =>
  import('@/pages/individual-partners/poland-invoice/RydCallBackApisGeneralInfo.vue');
const RydCallbackApiReference = () =>
  import('@/pages/individual-partners/poland-invoice/RydCallbackApiReference.vue');
const RydOAuthApiReference = () =>
  import('@/pages/individual-partners/poland-invoice/RydOAuthApiReference.vue');
const EparagonPlusApiReference = () =>
  import('@/pages/individual-partners/poland-invoice/EparagonPlusApiReference.vue');
const SmartOrderApiReference = () =>
  import('@/pages/individual-partners/poland-invoice/SmartOrderApiReference.vue');

export const individualPartnersRoutes: AppRouteRecordRaw[] = [
  {
    path: '/individual-partners',
    component: Body,
    meta: {
      requiresAuth: true,
      breadcrumb: 'Individual Partners',
    },
    children: [
      {
        path: 'reconcilation-process/fleetcor',
        name: 'fleetcorReconliationProcessInfo',
        component: FleetcorReconliationProcessInfo,
        meta: {
          title: 'Reconcilation Process Info | ryd Portal',
          breadcrumb: 'Fleetcor CSV Format Documentation',
        },
      },
      {
        path: 'fleetcor/reconciliation-dashboard',
        name: 'fleetcorReconciliationDashboard',
        component: FleetcorReconciliationDashboard,
        meta: {
          title: 'Fleetcor Reconciliation Dashboard | ryd Portal',
          breadcrumb: 'Fleetcor Reconciliation Dashboard',
        },
      },
      {
        path: 'fleetcor/job-executions',
        name: 'fleetcorJobExecutions',
        component: FleetcorJobExecutions,
        meta: {
          title: 'Fleetcor Export History | ryd Portal',
          breadcrumb: 'Fleetcor Export History',
        },
      },
      {
        path: 'fleetcor/job-executions/execution-details',
        name: 'fleetcorJobExecutionDetails',
        component: FleetcorJobExecutionDetails,
        meta: {
          title: 'Fleetcor Export Details | ryd Portal',
          breadcrumb: 'Fleetcor Export Details',
        },
      },
      {
        path: 'fleetcor/reconciliation-files',
        name: 'fleetcorReconciliationFiles',
        component: FleetcorReconciliationFiles,
        meta: {
          title: 'Fleetcor Download Files | ryd Portal',
          breadcrumb: 'Fleetcor Download Files',
        },
      },
      {
        // Backward-compat redirect: moved to Account Management.
        path: 'account-settings',
        redirect: '/account-management/account-settings-individual',
      },

      // exorigo_upos individual partners routes
      {
        // Backward-compat redirect: moved to Account Management.
        path: 'account-settings-poland-invoice',
        redirect: '/account-management/account-settings-poland-invoice',
      },
      {
        path: 'poland-invoice/general-info',
        name: 'poland-invoice-general-info',
        component: RydCallBackApisGeneralInfo,
        meta: {
          title: ' Poland Invoice APIs - General Information | ryd Portal',
          requiredPartnerTypes: ['INDIVIDUAL_PARTNER'],
          requiredUserGroup: ['exorigo_upos'],
          breadcrumb: 'Poland Invoice APIs - General Information',
        },
      },
      {
        path: 'poland-invoice/webhook-api-reference',
        name: 'poland-invoice-webhook-api-reference',
        component: RydCallbackApiReference,
        meta: {
          title: ' Poland Invoice Webhook API Reference | ryd Portal',
          requiredPartnerTypes: ['INDIVIDUAL_PARTNER'],
          requiredUserGroup: ['exorigo_upos'],
          breadcrumb: 'Poland Invoice Webhook API',
        },
      },
      {
        path: 'poland-invoice/oauth-api-reference',
        name: 'poland-invoice-oauth-api-reference',
        component: RydOAuthApiReference,
        meta: {
          title: ' OAuth2 API Reference | ryd Portal',
          requiredPartnerTypes: ['INDIVIDUAL_PARTNER'],
          requiredUserGroup: ['exorigo_upos'],
          breadcrumb: 'OAuth2 Authentication API',
        },
      },
      {
        path: 'poland-invoice/eparagon-plus-api-reference',
        name: 'poland-invoice-eparagon-plus-api-reference',
        component: EparagonPlusApiReference,
        meta: {
          title: ' e-Paragon+ API Reference | ryd Portal',
          requiredPartnerTypes: ['INDIVIDUAL_PARTNER'],
          requiredUserGroup: ['exorigo_upos'],
          breadcrumb: 'e-Paragon+ API Reference',
        },
      },
      {
        path: 'poland-invoice/smart-order-api-reference',
        name: 'poland-invoice-smart-order-api-reference',
        component: SmartOrderApiReference,
        meta: {
          title: ' SmartOrder API Reference | ryd Portal',
          requiredPartnerTypes: ['INDIVIDUAL_PARTNER'],
          requiredUserGroup: ['exorigo_upos'],
          breadcrumb: 'SmartOrder API Reference',
        },
      },

      // BMW fleet whitelist pages (VIN + driver import APIs)
      ...bmwIndividualPartnerRoutes,
    ],
  },

  // Redirect for backwards compatibility
  {
    path: '/pages/individual-partners/:pathMatch(.*)*',
    redirect: (to) => {
      return to.path.replace('/pages/individual-partners', '/individual-partners');
    },
  },

  // Account settings for individual partners, surfaced under Account Management.
  {
    path: '/account-management/account-settings-individual',
    component: Body,
    meta: {
      requiresAuth: true,
      breadcrumb: 'Account Management',
    },
    children: [
      {
        path: '',
        name: 'accountSettingsIndividualPartners',
        component: AccountSettingsIndividualPartner,
        meta: {
          title: 'Partner Portal Account Settings | ryd Portal',
          breadcrumb: 'Account Settings',
        },
      },
    ],
  },
  // exorigo_upos individual partners route
  {
    path: '/account-management/account-settings-poland-invoice',
    component: Body,
    meta: {
      requiresAuth: true,
      breadcrumb: 'Account Management',
    },
    children: [
      {
        path: '',
        name: 'accountSettingsPolandInvoice',
        component: AccountSettingsPolandInvoice,
        meta: {
          title: 'Partner Portal Account Settings | ryd Portal',
          requiredPartnerTypes: ['INDIVIDUAL_PARTNER'],
          requiredUserGroup: ['exorigo_upos'],
          breadcrumb: 'Poland Invoice - Account Settings',
        },
      },
    ],
  },
];
